import {
	AUTH_LOGOUT,
	ERROR,
	SAVE_STATE,
	LOAD_STATE,
} from './actionTypes';
import { LOCALSTORAGE_STATE_KEY } from './constants';

export const actions = {
	[ERROR]: ({ commit }, { moduleKey, stateKey, err, show = true }) => {
		commit(ERROR, { moduleKey, stateKey, err, show });
		if (err.response && err.response.status && (err.response.status === 401)) {
			commit(AUTH_LOGOUT);
		}
	},
	[SAVE_STATE]: ({ state, commit }) => {
		Object.keys(state.pages).forEach((page) => commit(`pages/${page}/beforeRefresh`));

		const stateToSave = JSON.stringify({
			pages: state.pages,
			pageManager: state.pageManager,
		});

		window.localStorage.setItem(LOCALSTORAGE_STATE_KEY, stateToSave);
	},

	[LOAD_STATE]: ({ commit }) => {
		commit(LOAD_STATE);
	},

};
